import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//引入elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
//引入修改鼠标右键事件
import Contextmenu from "v-contextmenu-directive"
//引入vueI18处理语言切换
import VueI18n from 'vue-i18n';
//引入外部icon
import "../static/icon/iconfont.css"
//封装函数，全局挂载到Vue实例上
import format from "./plugins/format"//时间处理
import request from "./api/index"//请求
//导入导出excel表格组件
import JsonExcel from 'vue-json-excel'
import AES from '@/components/AES'

// import ElTreeSelect from 'el-tree-select';

// Vue.use(ElTreeSelect);
Vue.prototype.$aes = AES
Vue.use(ElementUI,{size:"small"});//elementUI
Vue.use(VueI18n)
Vue.use(format)
Vue.use(request)
Vue.use(Contextmenu)
Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false

import CN from "@/languages/Chinese"
// import EN from "@/languages/English"
let newCN = {}
for (var key in CN) {
  newCN[key] = key.replace(/_/g, ' ')
}

const i18n=new VueI18n({
  locale:localStorage.getItem("wms-local")||"zh",
  messages:{
    zh:{
      ...zhLocale,//elementui中文包
      ...CN
    },
    en:{
      ...enLocale,//elementui英文包
      ...newCN
    }
  },
  silentTranslationWarn: true
})
ElementLocale.i18n((key, value) => i18n.t(key, value))
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
